import { render, staticRenderFns } from "./AppCell.vue?vue&type=template&id=f4f54c84&"
import script from "./AppCell.vue?vue&type=script&lang=js&"
export * from "./AppCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports